/**
 * Cable Glands template — thread-family tab switcher (§03).
 *
 * Markup contract (page-cable-glands.php):
 *   <section data-cg-tabs>
 *     <button data-cg-tab="metric" aria-controls="…" class="is-active">
 *     <div data-cg-panel="metric">…</div>  (others hidden)
 *
 * No-JS fallback: the first panel renders un-hidden, the rest stay
 * hidden — the METRIC table is always readable.
 */
const initTabs = (root) => {
    const tabs   = [...root.querySelectorAll('[data-cg-tab]')];
    const panels = [...root.querySelectorAll('[data-cg-panel]')];
    if (!tabs.length || !panels.length) return;

    const activate = (tab, focus) => {
        const key = tab.dataset.cgTab;
        tabs.forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach((p) => {
            if (p.dataset.cgPanel === key) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
        });
        if (focus) tab.focus();
    };

    tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab, false));
        tab.addEventListener('keydown', (e) => {
            const delta = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
            if (!delta) return;
            e.preventDefault();
            activate(tabs[(i + delta + tabs.length) % tabs.length], true);
        });
    });
};

const init = () => {
    document.querySelectorAll('[data-cg-tabs]').forEach(initTabs);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
